module.exports = __webpack_public_path__ + "static/media/suraajks.0c3226c5.jpg";